import { SetStateAction, useEffect } from "react";
import { ModalWithButtons } from "./modal";
import { SkyBlueButton, CustomIconButton, BlueButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
// import CountryProvinceSelector from "../countryAndProvinceSelector";
import { useState } from "react";
import { CustomDropdown, CustomTextInput } from "../inputs";
import { sendPOSTRequest } from "../../requestHelper/sendRequest";
import { useSnackbar } from "../toast/showToastMessage";
import { Severity, UserType } from "node-library/dist/constants";
import { GreenTickIcon } from "../toast/successIcons";
import { RedErrorIcon } from "../toast/errorIcons";
import { getUserRoles } from "../../helpers/userHelper";
import Config from "../../globals/Config";
import { ButtonTextLoadingAnimation } from "../animation/ButtonLoadingAnimation";
import KeyboardArrowLeftIconRounded from "@mui/icons-material/KeyboardArrowLeft";
import { YellowWarnIcon } from "../toast/warnIcons";
import {
	BillingInfo,
	FrontendUserInfo,
	RosterUserInfo,
	ShippingInfo,
} from "node-library/dist/portal";
import { useNavigate } from "react-router-dom";
import { roleMeetsRequirement } from "node-library/dist/helpers/request_helper";
import { validateEmail } from "../../helpers/inputHelper";
import e from "cors";

interface Props {
	open: boolean;
	user: RosterUserInfo;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
	setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
	goBackToViewUserDetailPage: (user: RosterUserInfo) => void;
	setIsUserProfileEdited: React.Dispatch<React.SetStateAction<boolean>>;
	setUser: React.Dispatch<React.SetStateAction<FrontendUserInfo | undefined>>;
}

export default function EditRosterUserModal(props: Props) {
	const { t: translation } = useTranslation();
	const {
		setUnsavedChanges,
		goBackToViewUserDetailPage,
		user,
		setIsUserProfileEdited,
	} = props;
	const { openSnackbar } = useSnackbar();

	const [editProfileStep, setEditProfileStep] = useState<number>(0);

	const [email, setEmail] = useState<string>(user.userName);
	const [firstName, setFirstName] = useState<string>(user.firstName);
	const [lastName, setLastName] = useState<string>(user.lastName);
	//client address info
	// const [clientCompanyName, setClientCompanyName] = useState<string>(
	// 	user.clientCompanyName
	// );
	const [role, setRole] = useState<UserType>(user.role);

	// const [address, setAddress] = useState<string>(user.address);
	// const [city, setCity] = useState<string>(user.city);
	// const [province, setProvince] = useState<string>(user.province);
	// const [postalCode, setPostalCode] = useState<string>(user.postalCode);
	// const [country, setCountry] = useState<string>(user.country);
	const [phoneNumber, setPhoneNumber] = useState<string>(user.phoneNumber);

	// billing info
	const [billingInfo, setBillingInfo] = useState<BillingInfo>({
		name: user.defaultBillingName || "",
		company: user.defaultBillingCompany || "",
		address: user.defaultBillingAddress || "",
		city: user.defaultBillingCity || "",
		postalCode: user.defaultBillingPostalCode || "",
		province: user.defaultBillingProvince || "",
		country: user.defaultBillingCountry || "",
		phoneNumber: user.defaultBillingPhoneNumber || "",
		email: user.defaultBillingEmail || "",
	});

	const [billingErrorMsg, setBillingErrorMsg] = useState<BillingInfo>({
		name: "",
		company: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
		email: "",
	});

	// shipping info
	const [shippingInfo, setShippingInfo] = useState<ShippingInfo>({
		name: user.defaultShippingName || "",
		address: user.defaultShippingAddress || "",
		city: user.defaultShippingCity || "",
		postalCode: user.defaultShippingPostalCode || "",
		province: user.defaultShippingProvince || "",
		country: user.defaultShippingCountry || "",
		phoneNumber: user.defaultShippingPhoneNumber || "",
	});

	const [shippingErrorMsg, setShippingErrorMsg] = useState<ShippingInfo>({
		name: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
	});
	//validations
	const [emailErrorMsg, setEmailErrorMsg] = useState<string>("");
	const [firstNameErrorMsg, setFirstNameErrorMsg] = useState<string>("");
	const [lastNameErrorMsg, setLastNameErrorMsg] = useState<string>("");
	//client address info
	// const [clientCompanyNameErrorMsg, setClientCompanyNameErrorMsg] =
	// 	useState<string>("");
	const [roleErrorMsg, setRoleErrorMsg] = useState<string>("");

	// const [addressErrorMsg, setAddressErrorMsg] = useState<string>("");
	// const [cityErrorMsg, setCityErrorMsg] = useState<string>("");
	// const [provinceErrorMsg, setProvinceErrorMsg] = useState<string>("");
	// const [postalCodeErrorMsg, setPostalCodeErrorMsg] = useState<string>("");
	// const [countryErrorMsg, setCountryErrorMsg] = useState<string>("");
	const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState<string>("");

	const [loading, setLoading] = useState<boolean>(false);

	function goBack() {
		if (editProfileStep === 1) {
			setEditProfileStep(0);
		} else if (editProfileStep === 2) {
			setEditProfileStep(1);
		}
	}

	const fieldsForEditProfileStepOne: Array<any> = [
		{
			id: "register-email-input",
			label: `${translation("Email")}`,
			inputType: "email",
			value: email,
			setValue: setEmail,
			required: true,
			errorMsg: emailErrorMsg,
			setErrorMsg: setEmailErrorMsg,
			disabled: true,
		},

		{
			id: "register-firstname-input",

			label: `${translation("FirstName")}`,
			inputType: "text",
			value: firstName,
			setValue: setFirstName,
			errorMsg: firstNameErrorMsg,
			setErrorMsg: setFirstNameErrorMsg,
		},
		{
			id: "register-lastname-input",

			label: `${translation("LastName")}`,
			inputType: "text",
			value: lastName,
			setValue: setLastName,
			errorMsg: lastNameErrorMsg,
			setErrorMsg: setLastNameErrorMsg,
		},
		{
			id: "register-phone-input",

			label: `${translation("PhoneNumber")}`,
			inputType: "tel",
			value: phoneNumber,
			setValue: setPhoneNumber,
			errorMsg: phoneNumberErrorMsg,
			setErrorMsg: setPhoneNumberErrorMsg,
		},
	];

	// const fieldsForEditProfileStepTwo: Array<any> = [
	// 	{
	// 		id: "register-company-name-input",

	// 		label: `${translation("CompanyName")}`,
	// 		inputType: "text",
	// 		value: clientCompanyName,
	// 		setValue: setClientCompanyName,
	// 		errorMsg: clientCompanyNameErrorMsg,
	// 		setErrorMsg: setClientCompanyNameErrorMsg,
	// 	},
	// 	{
	// 		id: "register-address-input",

	// 		label: `${translation("Address")}`,
	// 		inputType: "text",
	// 		value: address,
	// 		setValue: setAddress,
	// 		errorMsg: addressErrorMsg,
	// 		setErrorMsg: setAddressErrorMsg,
	// 	},
	// 	{
	// 		id: "register-city-input",

	// 		label: `${translation("City")}`,
	// 		inputType: "text",
	// 		value: city,
	// 		setValue: setCity,
	// 		errorMsg: cityErrorMsg,
	// 		setErrorMsg: setCityErrorMsg,
	// 	},
	// 	{
	// 		id: "register-postal-code-input",
	// 		label: `${translation("PostalCodeOrZip")}`,
	// 		inputType: "text",
	// 		value: postalCode,
	// 		setValue: setPostalCode,
	// 		errorMsg: postalCodeErrorMsg,
	// 		setErrorMsg: setPostalCodeErrorMsg,
	// 	},
	// 	{
	// 		id: "register-country-input",
	// 		label: `${translation("Country")}`,
	// 		inputType: "text",
	// 		value: country,
	// 		setValue: setCountry,
	// 		errorMsg: countryErrorMsg,
	// 		setErrorMsg: setCountryErrorMsg,
	// 	},
	// 	{
	// 		id: "register-province-input",

	// 		label: `${translation("ProvinceOrState")}`,
	// 		inputType: "text",
	// 		value: province,
	// 		setValue: setProvince,
	// 		errorMsg: provinceErrorMsg,
	// 		setErrorMsg: setProvinceErrorMsg,
	// 	},
	// ];

	const billingFields = [
		{ id: "name", label: translation("ContactName") },
		{ id: "company", label: translation("CompanyName"), notRequired: true },
		{ id: "email", label: translation("Email") },
		{ id: "phoneNumber", label: translation("Phone") },
		{ id: "address", label: translation("StreetAddress") },
		{ id: "postalCode", label: translation("PostalCodeOrZip") },
		{ id: "city", label: translation("City") },
		{ id: "country", label: translation("Country") },
		{ id: "province", label: translation("ProvinceOrState") },
	];

	const shippingFields = [
		{ id: "name", label: translation("ContactName") },
		{ id: "phoneNumber", label: translation("Phone") },
		{ id: "address", label: translation("StreetAddress") },
		{ id: "postalCode", label: translation("PostalCodeOrZip") },
		{ id: "city", label: translation("City") },
		{ id: "country", label: translation("Country") },
		{ id: "province", label: translation("ProvinceOrState") },
	];
	const roles: UserType[] = [
		UserType.ADMIN,
		UserType.ENGINEER_ADMIN,
		UserType.ENGINEER,
		UserType.SHIPPING,
		UserType.CLIENT,
	];

	function handleStepOneVerify() {
		let hasError: boolean = false;
		for (const field of fieldsForEditProfileStepOne) {
			if (
				field.required &&
				(!field.value || (field.value as string).trim().length == 0)
			) {
				field.setErrorMsg(translation("MissingInformation"));
				hasError = true;
			} else {
				field.setErrorMsg("");
			}
		}

		if (!role) {
			setRoleErrorMsg(translation("MissingInformation"));
			hasError = true;
		}

		if (hasError) {
			return;
		}

		//additional validations
		// if (phoneNumber.trim().length > 0 && phoneNumber.trim().length < 7) {
		// 	setPhoneNumberErrorMsg("InvalidPhoneNumber");
		// 	return;
		// }

		setEditProfileStep(1);
	}

	function handleStepTwoVerify() {
		console.log("handleStepTwoVerify");
		//additional validations
		if (billingInfo.email.trim.length > 0 && !validateEmail(email)) {
			setBillingErrorMsg((prev) => ({
				...prev,
				["email"]: translation("InvalidEmail"),
			}));
			return;
		}

		if (
			billingInfo.phoneNumber.trim().length > 0 &&
			billingInfo.phoneNumber.trim().length < 7
		) {
			setBillingErrorMsg((prev) => ({
				...prev,
				["phoneNumber"]: translation("InvalidPhoneNumber"),
			}));
			return;
		}

		setEditProfileStep(2);
	}
	async function handleSubmit() {
		// let hasError: boolean = false;

		// Simple validation for required fields
		// for (const field of fieldsForEditProfileStepTwo) {
		// if (
		// 	field.required &&
		// 	(!field.value || (field.value as string).trim().length == 0)
		// ) {
		// 	field.setErrorMsg(translation("MissingInformation"));
		// 	hasError = true;
		// } else {
		// 	field.setErrorMsg("");
		// }
		// }
		// for (const field of fieldsForCountryAndProvince) {
		// 	if (
		// 		field.required &&
		// 		(!field.value || (field.value as string).trim().length == 0)
		// 	) {
		// 		field.setErrorMsg(translation("MissingInformation"));
		// 		hasError = true;
		// 	} else {
		// 		field.setErrorMsg("");
		// 	}
		// }

		//validate country and province
		// if (!country || country.trim().length == 0) {
		// 	setCountryErrorMsg(translation("MissingInformation"));
		// }
		// if (hasError) {
		// 	return;
		// }
		if (
			shippingInfo.phoneNumber.trim().length > 0 &&
			shippingInfo.phoneNumber.trim().length < 7
		) {
			setShippingErrorMsg((prev) => ({
				...prev,
				["phoneNumber"]: translation("InvalidPhoneNumber"),
			}));
			return;
		}

		try {
			setLoading(true);

			const response = await sendPOSTRequest(
				"/users/admin-update-user-profile",
				{
					userId: user.userId,
					firstName: firstName.trim(),
					lastName: lastName.trim(),
					// clientCompanyName: clientCompanyName.trim(),
					role: role,
					// address: address.trim(),
					// city: city.trim(),
					// province: province.trim(),
					// country: country.trim(),
					// postalCode: postalCode.trim(),
					phoneNumber: phoneNumber.trim(),
					billingName: billingInfo.name.trim(),
					billingCompany: billingInfo.company.trim(),
					billingAddress: billingInfo.address.trim(),
					billingCity: billingInfo.city.trim(),
					billingProvince: billingInfo.province.trim(),
					billingCountry: billingInfo.country.trim(),
					billingPostalCode: billingInfo.postalCode.trim(),
					billingPhoneNumber: billingInfo.phoneNumber.trim(),
					billingEmail: billingInfo.email.trim(),

					shippingName: shippingInfo.name.trim(),
					shippingAddress: shippingInfo.address.trim(),
					shippingCity: shippingInfo.city.trim(),
					shippingProvince: shippingInfo.province.trim(),
					shippingCountry: shippingInfo.country.trim(),
					shippingPostalCode: shippingInfo.postalCode.trim(),
					shippingPhoneNumber: shippingInfo.phoneNumber.trim(),
				}
			);

			openSnackbar(
				translation("UserProfileUpdated"),
				Severity.SUCCESS,
				undefined,
				<GreenTickIcon />
			);

			setUnsavedChanges(false);
			setIsUserProfileEdited(true);

			if (response?.success) {
				if (response?.userInfo) {
					localStorage.setItem(
						"billionspectra_userInfo",
						JSON.stringify(response.userInfo)
					);
					props.setUser(response?.userInfo as FrontendUserInfo);
				}
			}
			props.setOpen(false);
			setEditProfileStep(0);
			goBackToViewUserDetailPage(response?.rosterUserInfo);
		} catch (err: any) {
			openSnackbar(
				translation("SystemError"),
				Severity.ERROR,
				translation("SystemErrorMsg"),
				<RedErrorIcon />
			);
		} finally {
			setLoading(false);
		}
	}

	const editprofileInputsStepOne: Array<React.ReactNode> =
		fieldsForEditProfileStepOne.map((field, index) => {
			return (
				<CustomTextInput
					id={field.id}
					key={field.id}
					value={field.value}
					setValue={(value) => {
						field.setValue(value);
						setUnsavedChanges(true);
					}}
					label={field.label}
					type={field.type}
					required={field.required}
					errorMsg={field.errorMsg}
					setErrorMsg={field.setErrorMsg}
					disabled={field.disabled || false}
				></CustomTextInput>
			);
		});

	const billingForm: Array<React.ReactNode> = billingFields.map(
		({ id, label }) => (
			<CustomTextInput
				key={id}
				id={`billing-${id}-input`}
				label={label}
				value={billingInfo[id as keyof BillingInfo]}
				setValue={(value) => {
					setBillingInfo((prev) => ({ ...prev, [id]: value }));
					setUnsavedChanges(true);
				}}
				errorMsg={billingErrorMsg[id as keyof BillingInfo]}
				setErrorMsg={(error) =>
					setBillingErrorMsg((prev) => ({ ...prev, [id]: error }))
				}
			/>
		)
	);
	const shippingForm: Array<React.ReactNode> = shippingFields.map(
		({ id, label }) => (
			<CustomTextInput
				key={id}
				id={`shipping-${id}-input`}
				label={label}
				value={shippingInfo[id as keyof ShippingInfo]}
				setValue={(value) => {
					setShippingInfo((prev) => ({ ...prev, [id]: value }));
					setUnsavedChanges(true);
				}}
				errorMsg={shippingErrorMsg[id as keyof ShippingInfo]}
				setErrorMsg={(error) =>
					setShippingErrorMsg((prev) => ({ ...prev, [id]: error }))
				}
			/>
		)
	);
	const isUserAdmin: boolean = roleMeetsRequirement(user.role, UserType.ADMIN);
	const roleSelector: React.ReactNode = (
		<CustomDropdown
			id="role-dropdown"
			label={translation("Role")}
			options={roles.map((value) => {
				return {
					value: value,
					title: getUserRoles(value, translation),
				};
			})}
			value={role}
			setValue={(value) => {
				setRole(value);
				setUnsavedChanges(true);
			}}
			disabled={isUserAdmin}
		></CustomDropdown>
	);

	const editProfileStepOneContent: React.ReactNode = (
		<div className="registration-input-content">
			{editprofileInputsStepOne[0]}

			<div className="register-grid-row">
				{editprofileInputsStepOne[1]}
				{editprofileInputsStepOne[2]}
			</div>
			{editprofileInputsStepOne[3]}
			{roleSelector}
		</div>
	);

	const editProfileStepTwoContent: React.ReactNode = (
		<div className="registration-input-content">
			<div className="typography-heading-04">
				{translation("DefaultBillingInformation")}
			</div>
			<div className="register-grid-row">
				{billingForm[0]}
				{billingForm[1]}
			</div>
			<div className="register-grid-row">
				{billingForm[2]}
				{billingForm[3]}
			</div>
			{billingForm[4]}
			<div className="register-grid-row">
				{billingForm[5]}
				{billingForm[6]}
			</div>
			<div className="register-grid-row">
				{billingForm[7]}
				{billingForm[8]}
			</div>
			{/* <div className="register-grid-row">
				<CountryProvinceSelector
					countryDropdownId={"register-country-input"}
					provinceDropdownId={"register-province-input"}
					selectedCountryName={country}
					setSelectedCountryName={setCountry}
					selectedState={province}
					setSelectedState={setProvince}
				/>
			</div> */}
		</div>
	);

	const editProfileStepThreeContent: React.ReactNode = (
		<div className="registration-input-content">
			<div className="typography-heading-04">
				{translation("DefaultShippingInformation")}
			</div>
			<div className="register-grid-row">
				{shippingForm[0]}
				{shippingForm[1]}
			</div>
			{shippingForm[2]}
			<div className="register-grid-row">
				{shippingForm[3]}
				{shippingForm[4]}
			</div>
			<div className="register-grid-row">
				{shippingForm[5]}
				{shippingForm[6]}
			</div>
			{/* <div className="register-grid-row">
				<CountryProvinceSelector
					countryDropdownId={"register-country-input"}
					provinceDropdownId={"register-province-input"}
					selectedCountryName={country}
					setSelectedCountryName={setCountry}
					selectedState={province}
					setSelectedState={setProvince}
				/>
			</div> */}
		</div>
	);

	const editProfileStepOneButton: React.ReactNode = (
		<BlueButton
			id="register-next-button"
			children={translation("Next")}
			size={"flex"}
			onClick={() => {
				handleStepOneVerify();
			}}
		></BlueButton>
	);
	const editProfileStepTwoButton: React.ReactNode = (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
			}}
		>
			<SkyBlueButton
				id="register-back-button"
				children={translation("Back")}
				size={"flex"}
				onClick={() => {
					goBack();
				}}
			></SkyBlueButton>
			<BlueButton
				id="register-next-button"
				children={translation("Next")}
				size={"flex"}
				disabled={loading}
				onClick={() => {
					handleStepTwoVerify();
				}}
			></BlueButton>
		</div>
	);
	const editProfileStepThreeButton: React.ReactNode = (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
			}}
		>
			<SkyBlueButton
				id="register-back-button"
				children={translation("Back")}
				size={"flex"}
				onClick={() => {
					goBack();
				}}
			></SkyBlueButton>
			<BlueButton
				id="register-next-button"
				children={
					loading ? (
						<ButtonTextLoadingAnimation
							text={translation("Loading")}
						></ButtonTextLoadingAnimation>
					) : (
						translation("Save")
					)
				}
				size={"flex"}
				disabled={loading}
				onClick={() => {
					handleSubmit();
				}}
			></BlueButton>
		</div>
	);

	let editprofileContent: React.ReactNode = editProfileStepOneContent;

	let editprofileButton: React.ReactNode = editProfileStepOneButton;

	switch (editProfileStep) {
		case 0:
			editprofileContent = editProfileStepOneContent;
			editprofileButton = editProfileStepOneButton;
			break;
		case 1:
			editprofileContent = editProfileStepTwoContent;
			editprofileButton = editProfileStepTwoButton;
			break;
		case 2:
			editprofileContent = editProfileStepThreeContent;
			editprofileButton = editProfileStepThreeButton;
			break;
	}

	const modal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={translation("UpdateUserProfile")}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%",
					}}
				>
					{editprofileButton}
				</div>,
			]}
		>
			<div className="login-container">
				<div className="register-step-indicator-row">
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								editProfileStep >= 0
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								editProfileStep >= 1
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								editProfileStep >= 2
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
				</div>

				{editprofileContent}

				{/* <form onSubmit={handleSubmit}>
				{editprofileInputs}

				

				<button type="submit">{translation("Register")}</button>
				<button onClick={() => props.setCurrentPage(CurrentLoginPage.LOGIN)}>
					{translation("Back")}
				</button>
			</form> */}
			</div>
		</ModalWithButtons>
	);

	return modal;
}
